import moment from 'moment'
import api from '../../services/service'

export default {
  data () {
    return {
      title: 'เพิ่ม',
      status: '2',
      assess_title: '',
      assess_description: '',
      year: 2000,
      time_start: moment(new Date()),
      time_end: moment(new Date()),
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      assess_type: '1'
    }
  },
  methods: {
    moment,
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.$route.params.round_id) {
            var payload = {
              round_id: this.$route.params.round_id,
              title: values.หัวข้อแบบประเมิน,
              year: values.ปี,
              description: this.assess_description,
              date_start: this.time_start,
              date_end: this.time_end,
              round_status: this.status,
              assessment_type: this.assess_type

            }
            this.editRound(payload)
          } else {
            var data = {
              title: values.หัวข้อแบบประเมิน,
              year: values.ปี,
              description: this.assess_description,
              date_start: this.time_start,
              date_end: this.time_end,
              round_status: this.status,
              assessment_type: this.assess_type
            }
            this.addRound(data)
          }
        }
      })
    },
    getRound (id) {
      this.$store.state.isLoading = true
      api.getRoundDetail(
        id,
        result => {
          if (result.result === true) {
            this.assess_title = result.data.title
            this.assess_description = result.data.description
            this.year = parseInt(result.data.year)
            this.time_start = this.moment(result.data.date_start)
            this.time_end = this.moment(result.data.date_end)
            this.status = result.data.round_status
            this.assess_type = result.data.assessment_type
          } else {
            this.$notification['warning']({
              message: 'ข้อมูลแบบประเมิน',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$notification['error']({
            message: 'ข้อมูลแบบประเมิน',
            description: error
          })
          this.$store.state.isLoading = false
        }
      )
    },
    addRound (obj) {
      this.$store.state.isLoading = true
      api.newRound(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'เพิ่มแบบประเมิน',
              description: result.data
            })
            this.$router.push({ name: 'rounds' })
          } else {
            this.$notification['warning']({
              message: 'เพิ่มแบบประเมิน',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$notification['error']({
            message: 'เพิ่มแบบประเมิน',
            description: error
          })
          this.$store.state.isLoading = false
        }
      )
    },
    editRound (obj) {
      this.$store.state.isLoading = true
      api.updateRound(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'แก้ไขแบบประเมิน',
              description: result.data
            })
            this.$router.push({ name: 'rounds' })
          } else {
            this.$notification['warning']({
              message: 'แก้ไขแบบประเมิน',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$notification['error']({
            message: 'แก้ไขแบบประเมิน',
            description: error
          })
          this.$store.state.isLoading = false
        }
      )
    },
    handleSelectChange (value) {
      this.status = value
    },
    handleTypeSelectChange (value) {
      this.assess_type = value
    }
  },
  mounted () {
    if (this.$route.params.round_id) {
      this.title = 'แก้ไข'
      this.getRound(this.$route.params.round_id)
    }
    this.setUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/roundform.js